import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Guard que redireciona admins para /admin quando tentam acessar /dashboard
 * Admin NUNCA deve ver o dashboard - sempre vai para o painel admin
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardRedirectGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.authState$.pipe(
      take(1),
      map((authState) => {
        // Se não está autenticado, deixa o AuthGuard lidar
        if (!authState.isAuthenticated) {
          return true;
        }

        // Se é admin, redireciona para /admin
        if (this.authService.isAdmin()) {
          this.router.navigate(['/admin']);
          return false;
        }

        // Não é admin, pode acessar o dashboard
        return true;
      }),
    );
  }
}
